export default class ErrorCode {
  public message: string;
  constructor(message: string) {
    this.message = message;
  }
}
